/**
 * @generated SignedSource<<86df0a58073ae617236c777a24afb809>>
 * @relayHash 8d86846f6b8634fce76ecccbef74cfb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0555913fbafe04d174c82b3133f71d79eb76badef68ceca0fb8548dc7d92b3b5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isJscInlineEditFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-inline-edit-fast-follows-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';
import simplifiedTimeTracking_provider from '@atlassian/jira-relay-provider/src/simplified-time-tracking.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0555913fbafe04d174c82b3133f71d79eb76badef68ceca0fb8548dc7d92b3b5",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": simplifiedTimeTracking_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider
    }
  }
};

export default node;
